import { Component, OnInit, Input, Output, Inject, EventEmitter, OnChanges } from '@angular/core';
import { S1DataService } from '../../services/s1data.service';

import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { mergeMap, map } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';

import { ICategory } from '../../models/ICategory';

@Component({
  selector: 'feza-category-picker',
  templateUrl: './category-picker.component.html',
  styleUrls: ['./category-picker.component.css']
})
export class CategoryPickerComponent implements OnInit, OnChanges {
  @Input() index: number;
  @Input() categories: Array<string>;
  @Input() showAddButton: boolean;
  @Output() categoryPicked: EventEmitter<Array<string>> = new EventEmitter();
  @Output() addItem: EventEmitter<void> = new EventEmitter();
  @Output() removeItem: EventEmitter<void> = new EventEmitter();
  categoryList: Array<ICategory>;
  mainCategoryList: Array<ICategory>;
  genericCategoriesList: Array<ICategory>;
  specificCategoriesList: Array<ICategory>;
  mainCategoryId?: number;
  genericCategoryId?: number;
  specificCategoryId?: number;

  constructor(private dataService: S1DataService)
  {
  }

  ngOnInit() {
    this.dataService.getCategories().subscribe(categories => {
      this.categoryList = categories; 
      this.mainCategoryList = this.categoryList.filter(x => x.parentId == 0);
      this.setup();
    }, err => {
      console.log(err);
    });
    
  }

  ngOnChanges() {
    //this.setup();
  }

  setup() {
    if (this.categories[0]) {
      this.onMainPicked(this.categoryList.find(x => x.name == this.categories[0]));
      this.onGenericPicked(this.categoryList.find(x => x.name == this.categories[1]));
      this.onSpecificPicked(this.categoryList.find(x => x.name == this.categories[2]),false);
    }
  }

  onMainPicked(mainCategory: ICategory) {
    if (mainCategory) {
      this.genericCategoryId = null;
      this.specificCategoryId = null;
      this.mainCategoryId = mainCategory.id;
      this.genericCategoriesList = this.categoryList.filter(x => x.parentId == this.mainCategoryId);
    }
  }

  onGenericPicked(genericCategory: ICategory) {
    this.specificCategoryId = null;
    this.genericCategoryId = genericCategory.id;
    this.specificCategoriesList = this.categoryList.filter(x => x.parentId == this.genericCategoryId);
  }

  onSpecificPicked(specificCategory: ICategory, notify: boolean = true) {
    this.specificCategoryId = specificCategory.id;
    var main = this.categoryList.find(x => x.id == this.mainCategoryId).name;
    var generic = this.categoryList.find(x => x.id == this.genericCategoryId).name;
    var specific = this.categoryList.find(x => x.id == this.specificCategoryId).name;
    if (notify)
      this.categoryPicked.emit([main, generic, specific, this.index.toString()]);
  }

  onCategoryAddButton() {
    this.addItem.emit();
  }

  onCategoryDeleteButton() {
    this.removeItem.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/category-picker/category-picker.component.ts